import React, { useState, useEffect } from "react";
import { Box, styled, Button } from "@mui/material";
import { FaXmark, FaArrowRightLong } from "react-icons/fa6";
import icon_gorrito from "../images/icon/ic-gorrito.svg";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { transformProducts } from "../helpers/productHelper";
import { Error500 } from "../alerts/Error";

const Container = styled(Box)(({ theme }) => ({
  width: "100%",
  backgroundColor: "#6384BD",
  padding: "1rem",
  display: "flex",
  flexWrap: "wrap",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: ".5rem",
  color: "#FFFFFF",
   position: "relative",
  [theme.breakpoints.up("lg")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "1.5rem 3rem",
  },
  [theme.breakpoints.down("sm")]: {
    display: "none", // Ocultar el componente en pantallas pequeñas
  },
}));

const FirstText = styled("p")(({ theme }) => ({
  marginBottom: 0,
  textAlign: "center",
  fontFamily: "Patua One",
  fontSize: "14px",
  lineHeight: 1,
  //min-width: 600px
  [theme.breakpoints.up("sm")]: {
    fontSize: "16px",
  },
  "@media(min-width:768px)": {
    fontSize: "20px",
  },
}));

const Icon = () => {
  return <img src={icon_gorrito} alt="icono gorrito" width={30} height={30} style={{ top: "-5px", position: "relative" }} />;
};

const BrFirstText = styled("br")(() => ({
  display: "block",
  "@media(min-width:768px)": {
    display: "none",
  },
}));

const SecondText = styled("p")(() => ({
  marginBottom: 0,
  fontFamily: "Patua One",
  fontSize: "9px",
  fontWeight: "normal",
  lineHeight: "12px",
  "@media(min-width:768px)": {
    fontSize: "14px",
  },
}));

const Link = styled("a")(() => ({
  textDecoration: "underline",
  color: "#e0e6f2",
}));

const HeaderOldCart = () => {
  const ResumenData = useSelector((state) => state.global.ResumenData);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Verificar en localStorage si el banner ya fue cerrado
    const closed = localStorage.getItem("headerOldCartClosed");
    if (closed === "true") {
      setIsVisible(false);
    }
  }, []);

  const handlerClickLink = (event) => {
    event.preventDefault();
    const base_url = process.env.REACT_APP_CLIENTES_BASE_URL;
    const result = transformProducts(ResumenData, true);

    // Crear un formulario
    const form = document.createElement("form");
    form.method = "POST";
    form.action = base_url + "addToCart.php";
    try {
      result.forEach((element, index) => {
        if (element.product_id) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `items[${index}][pid]`;
          input.value = element.product_id;
          form.appendChild(input);
        }

        if (element.billingcycle) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `items[${index}][billingcycle]`;
          input.value = element.billingcycle;
          form.appendChild(input);
        }

        if (element.domain) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `items[${index}][domain]`;
          input.value = element.domain;
          form.appendChild(input);
        }

        if (element.regperiod) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `items[${index}][regperiod]`;
          input.value = element.regperiod;
          form.appendChild(input);
        }

        if (element.domaintype) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `items[${index}][domaintype]`;
          input.value = element.domaintype;
          form.appendChild(input);
        }

        if (element.privacy_protection) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = `items[${index}][idprotection]`;
          input.value = element.privacy_protection;
          form.appendChild(input);
        }
      });

      // Agregar el formulario al DOM y enviarlo
      document.body.appendChild(form);

      form.submit();
    } catch (error) {
      console.log(error);
      Error500();
    }
  };

  const handleClose = () => {
    setIsVisible(false);
    // Guardar el estado en localStorage
    localStorage.setItem("headerOldCartClosed", "true"); 
  };
  
  // No mostrar el componente si está cerrado o no hay datos
  if (!isVisible || ResumenData.length === 0) {
    return null; 
  }

  return (
    <Container boxShadow={3}>
      <FirstText>
        <Icon /> ¡Estrenamos nuevo carrito!&nbsp;
        <BrFirstText />
        Disfruta de una experiencia mejorada.
      </FirstText>
      <SecondText>
        ¿Prefieres el carrito anterior?&nbsp;
        <Link href="#" onClick={handlerClickLink}>
          Vuelve aquí
        </Link>
        <FaArrowRightLong className="icon-header" style={{ marginTop: 2, marginLeft: 2 }} />
      </SecondText>
      <IoCloseCircle 
        onClick={handleClose} 
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          fontSize: "24px",
          cursor: "pointer",
          color: "#fff",
          transition: "opacity 0.3s"
        }}
      />
    </Container>
  );
};

export default HeaderOldCart;
